import { NgModule } from '@angular/core';
import {Routes, RouterModule, ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import { DummyComponent } from './components/alerts/dummy/dummy.component';
import { ResetPwComponent } from './components/alerts/reset-pw/reset-pw.component';
import {DebugComponent} from './components/debug/debug.component'
import {ProductComponent} from './product/product.component'
import { ThanksForEmailVerificationComponent } from './components/alerts/thanks-for-email-verification/thanks-for-email-verification.component';
import {Title, Meta} from "@angular/platform-browser";
import { MessengerComponent } from './components/messenger/messenger.component';


import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';


const routes: Routes = [

    {
        path: 'debug',
        component: DebugComponent,
        data: {
            title: 'loading...',
        },
        // resolve: { user: ResolverForUser }
    },
    {
        path: 'messenger',
        component: MessengerComponent,
        data: {
            title: 'Chat',
        },
        // resolve: { user: ResolverForUser }
    },
    {
        path: 'beta/thanksForEmailVerification',
        component: ThanksForEmailVerificationComponent,
        data: {
            title: 'Thanks For Email Verification',
        },
        // resolve: { user: ResolverForUser }
    },

    {
      path: 'resetPw',
      component: ResetPwComponent,
      data: {
           title: 'Reset your password',
      }
    },


    { path: 'p/:name', loadChildren: () => import('./components/user_components/user-profil/user-profil.module').then(m => m.UserProfilModule)},
    { path: 'notifications', loadChildren: () => import('./components/user_components/notifications/notifications.module').then(m => m.NotificationsModule),
        data: {
             title: 'whooosh | Notifications',
             description: 'Your whooosh notifications',
        }
    },
    { path: 'logout', loadChildren: () => import('./components/user_authentication/logout/logout.module').then(m => m.LogoutModule),
        data: {
             title: 'whooosh | Logout',
             description: 'Goodbye',
        }
    },
    { path: 'explore', loadChildren: () => import('./components/board/board-explore/board-explore.module').then(m => m.BoardExploreModule),
        data: {
             title: 'whooosh | Explore',
             description: 'Explore more boards',
        }
    },
    { path: 'create', loadChildren: () => import('./components/board/create/create.module').then(m => m.CreateModule),
        data: {
             title: 'whooosh | Create',
             description: 'Create a new whooosh board',
        }
    },
    { path: 'edit/:name', loadChildren: () => import('./components/board/edit/edit.module').then(m => m.EditModule),
        data: {
             title: 'whooosh | Edit',
             description: 'Edit your whooosh board',
        }
    },
    { path: 'contact', loadChildren: () => import('./components/about_whooosh/contact/contact.module').then(m => m.ContactModule),
        data: {
             title: 'whooosh | Contact',
             description: 'Here your can contact us',
        }
    },
    { path: 'faq', loadChildren: () => import('./components/about_whooosh/faq/faq.module').then(m => m.FaqModule),
        data: {
             title: 'whooosh | Faq',
             description: 'whooosh faqs',
        }
    },
    { path: 'imprint', loadChildren: () => import('./components/about_whooosh/imprint/imprint.module').then(m => m.ImprintModule),
        data: {
             title: 'whooosh | Imprint',
             description: 'whooosh imprint',
             keywords: 'abc, def'
        }
    },
    { path: 'policies', loadChildren: () => import('./components/about_whooosh/policies/policies.module').then(m => m.PoliciesModule),
        data: {
             title: 'whooosh | policies',
             description: 'Whooosh policies',
        }
    },
    { path: 'terms', loadChildren: () => import('./components/about_whooosh/terms/terms.module').then(m => m.TermsModule),
        data: {
             title: 'whooosh | terms',
             description: 'Whooosh terms',
        }
    },
    { path: 'whatiswhooosh', loadChildren: () => import('./components/about_whooosh/whatiswhooosh/whatiswhooosh.module').then(m => m.WhatiswhoooshModule),
        data: {
             title: 'whooosh | What is whooosh',
             description: 'Whooosh what is whooosh',
        }
    },
    { path: 'contactmessages', loadChildren: () => import('./componentsadmin/contact-messages/contact-messages.module').then(m => m.ContactMessagesModule) },
    { path: 'createaffiliatelink', loadChildren: () => import('./componentsadmin/createaffiliate/createaffiliate.module').then(m => m.CreateaffiliateModule) },
    { path: '', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
        data: {
             title: 'whooosh | Alle Netwerke auf einem Blick | Verpasse nix',
             description: 'Auf whooosh hast du Beiträge diverser Netzwerke wie z.B. Instagram, Tiktok, Twitter, Youtube uvm. auf einer Seite zusammengefasst! Folge auf whooosh deiner lieblings Fussballmannschaft und verpasse keinen Beitrag mehr',
             keywords: 'whooosh'
        }
    },
    { path: 'login', loadChildren: () => import('./components/user_authentication/login/login.module').then(m => m.LoginModule),
        data: {
             title: 'whooosh | Login',
             description: 'Login to your whooosh account',
             keywords: 'login'

        }
    },
    { path: 'register', loadChildren: () => import('./components/user_authentication/register/register.module').then(m => m.RegisterModule),
        data: {
             title: 'whooosh | Register',
             description: 'Create a free whooosh account',
             keywords: 'register'

        }
    },
    { path: 'resetpw', loadChildren: () => import('./components/user_authentication/reset-pw/reset-pw.module').then(m => m.ResetPwModule),
        data: {
             title: 'whooosh | Password reset',
             description: 'Reset your whooosh password',
        }
    },
    { path: 'collections', loadChildren: () => import('./components/user_components/collections/collections.module').then(m => m.CollectionsModule),
        data: {
             title: 'whooosh | Collections',
             description: 'Create your own social media magazin',
        }
    },
    { path: 'u', loadChildren: () => import('./components/user_components/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {
             title: 'whooosh | Dashboard',
             description: 'Your whooosh dashboard',
        }
    },
    { path: 'settings', loadChildren: () => import('./components/user_components/user-settings/user-settings.module').then(m => m.UserSettingsModule),
        data: {
             title: 'whooosh | Settings',
             description: 'Your whooosh settings',
        }
    },
    { path: 'videoplayer', loadChildren: () => import('./components/fixed_components/videoplayer/videoplayer.module').then(m => m.VideoplayerModule) },

    { path: 'feed', loadChildren: () => import('./components/user_components/feed/feed.module').then(m => m.FeedModule),
        data: {
             title: 'whooosh | Feed',
             description: 'Your whooosh feed',
        }
    },
    { path: 'messages', loadChildren: () => import('./components/user_components/messages/messages.module').then(m => m.MessagesModule) },

    { path: 'awards', loadChildren: () => import('./components/awards/awards.module').then(m => m.AwardsModule) },

    { path: 'sports/football', loadChildren: () => import('./components/landing/sports/football/football.module').then(m => m.FootballModule) },

    { path: 'sports/football/bundesliga', loadChildren: () => import('./components/landing/sports/football/bundesliga/bundesliga.module').then(m => m.BundesligaModule) },

    { path: 'sports/football/premierleague', loadChildren: () => import('./components/landing/sports/football/premierleague/premierleague.module').then(m => m.PremierleagueModule) },

    { path: 'sports/nfl', loadChildren: () => import('./components/landing/sports/nfl/nfl.module').then(m => m.NflModule) },

    { path: 'sports/basketball', loadChildren: () => import('./components/landing/sports/basketball/basketball.module').then(m => m.BasketballModule) },

    { path: 'sports/volleyball', loadChildren: () => import('./components/landing/sports/volleyball/volleyball.module').then(m => m.VolleyballModule) },

    { path: 'sports/handball', loadChildren: () => import('./components/landing/sports/handball/handball.module').then(m => m.HandballModule) },

    { path: 'art/graffiti', loadChildren: () => import('./components/landing/art/graffiti/graffiti.module').then(m => m.GraffitiModule) },

    { path: 'celebrities/tv', loadChildren: () => import('./components/landing/celebrities/tv/tv.module').then(m => m.TvModule) },

    { path: 'music/rapper', loadChildren: () => import('./components/landing/music/rapper/rapper.module').then(m => m.RapperModule) },

    { path: 'userContacts', loadChildren: () => import('./components/about_whooosh/user-contact/user-contact.module').then(m => m.UserContactModule) },

    {
      path: 'dummy',
      component: DummyComponent,
      data: {
           title: 'loading...',
      }
    },
    
    { path: ':name', loadChildren: () => import('./components/board/board.module').then(m => m.BoardModule)},







    { path: '**', loadChildren: () => import('./components/board/errorpage/errorpage.module').then(m => m.ErrorpageModule),
        data: {
             title: 'whooosh | 404',
             description: 'This page is not found',
        }
    },



];


@NgModule({
  imports: [RouterModule.forRoot(routes,  {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private metaService: Meta
    ){
        //Boilerplate code to filter out only important router events and to pull out data object field from each route
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter(route => route.outlet === 'primary')
            //Data fields are merged so we can use them directly to take title and metaDescription for each route from them
            .mergeMap(route => route.data)
            //Real action starts there
            .subscribe((event) => {
                //Changing title
                this.titleService.setTitle(event['title']);

                //Changing meta with name="description"
                var tag = { name: 'description', content: event['metaDescription'] };
                let attributeSelector : string = 'name="description"';
                this.metaService.removeTag(attributeSelector);
                this.metaService.addTag(tag, false);
                this.metaService.addTag({ name: 'test', content: 'very test'}, true);
            });
    }
}
